module.exports = __webpack_public_path__ + "static/media/icon-popup-bg.31f09aa7.png";